module.exports = __webpack_public_path__ + "media/images/public_block_link-59263a5e329c97f58d794064bbfe6446.svg";